function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState } from 'react';
import cn from 'classnames';
import { CloseButton, GridItem, TextButton, TextField, useOverlayContext, WithInfoIcon } from 'seagull';
import IntroVideoModal from "./IntroVideoModal/IntroVideoModal";
import VideoPlayer from "../../VideoPlayer/VideoPlayer";
import { isUrlValid } from "./IntroVideoModal/IntroVIdeoModal.utils";
import { makeIntroVideoLink, makeIntroVideoNone } from "../../../models/intro-video";
import { introVideoModel } from "../../../models";
import styles from "./IntroVideoField.module.scss";
const IntroVideoField = _ref => {
  let {
    introVideo,
    onChange,
    className,
    disabled
  } = _ref;
  const overlayContext = useOverlayContext();
  const [videoName, setVideoName] = useState('');
  const videoLink = introVideoModel.videoUrl(introVideo) || '';
  const onIntroVideoSave = (videoName, videoLink) => {
    setVideoName(videoName);
    onChange(makeIntroVideoLink(videoLink.trim()));
  };
  const openIntroVideoModal = async () => {
    await overlayContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: p => /*#__PURE__*/React.createElement(IntroVideoModal, _extends({
        onSave: onIntroVideoSave,
        videoLink: videoLink
      }, p))
    });
  };
  return /*#__PURE__*/React.createElement(GridItem, {
    span: 12,
    className: cn(styles.firstRow, className)
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: "This video will show as an introductory video on the proposal your client recieves"
  }, !videoName && /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "add-intro-video",
    disabled: disabled,
    underline: "none",
    onClick: openIntroVideoModal
  }, "+ Add an introductory video"), isUrlValid(videoLink) && !videoName && /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/React.createElement(VideoPlayer, {
    url: videoLink,
    onReady: _ref2 => {
      let {
        videoName
      } = _ref2;
      setVideoName(videoName);
    }
  })), videoName && /*#__PURE__*/React.createElement(TextField, {
    width: 512,
    label: "Introductory video",
    "data-testid": "intro-video-name",
    value: videoName,
    disabled: disabled,
    disableSuffixPadding: true,
    suffix: !disabled && /*#__PURE__*/React.createElement(CloseButton, {
      "data-testid": "intro-video-remove-video-name-button",
      skin: "transparent",
      onClick: () => {
        setVideoName('');
        onChange(makeIntroVideoNone());
      }
    })
  })), /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "intro-video-preview",
    onClick: openIntroVideoModal,
    disabled: disabled,
    style: {
      visibility: videoName ? 'visible' : 'hidden'
    }
  }, "Preview"));
};
export default IntroVideoField;